import React from "react";

const TONES = { green: "text-[#008057] bg-[#F2F8F5]", gold: "text-[#B8860B] bg-amber-50", amber: "text-amber-700 bg-amber-50", red: "text-red-600 bg-red-50" };

export function Stat({ icon: Icon, label, value, tone = "green" }) {
  return (
    <div className="rounded-2xl bg-white border border-[#E2EBF0] p-5 shadow-sm">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${TONES[tone]}`}><Icon size={20} /></div>
      <div className="font-display text-3xl font-extrabold text-[#03281B] mt-3">{value}</div>
      <div className="text-sm text-slate-500">{label}</div>
    </div>
  );
}

const REG_STATUS_CLS = { confirmed: "bg-[#008057] text-white", pending_payment: "bg-amber-100 text-amber-800" };

export function RegStatusBadge({ status, large }) {
  const cls = REG_STATUS_CLS[status] || "bg-red-100 text-red-700";
  return <span className={`text-xs font-bold ${large ? "px-3" : "px-2"} py-1 rounded-full ${cls}`}>{status.replace("_", " ")}</span>;
}

function sponsorBadge(s) {
  if (s.payment_status === "paid") return ["bg-[#008057] text-white", s.status.replace(/_/g, " ")];
  if (s.status === "cancelled") return ["bg-red-100 text-red-700", "pending payment"];
  return ["bg-amber-100 text-amber-800", "pending payment"];
}

export function SponsorStatusBadge({ s }) {
  const [cls, label] = sponsorBadge(s);
  return <span className={`text-xs font-bold px-2 py-1 rounded-full ${cls}`}>{label}</span>;
}

export const fmtUtc = (iso) => (iso ? `${iso.slice(0, 19).replace("T", " ")} UTC` : "\u2014");
export const H1 = ({ children }) => <h1 className="font-display text-3xl font-extrabold text-[#03281B]">{children}</h1>;
